module.exports = __webpack_public_path__ + "img/dni-frente.71879940.png";